export const getTimeGreeting = () => {
  const now = new Date();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const currentTime = hour + (minute / 60);

  // Pagi: 02:59-12:00
  if ((currentTime >= 2.98 && currentTime < 12) || (currentTime >= 0 && currentTime <= 3)) {
    return {
      greeting: "Selamat Pagi",
      icon: "fa-sun",
      gradient: "from-yellow-400 to-orange-500",
      bgGradient: "from-yellow-50 to-orange-50"
    };
  }
  // Siang: 12:01-15:00  
  else if (currentTime >= 12.02 && currentTime <= 15) {
    return {
      greeting: "Selamat Siang", 
      icon: "fa-sun",
      gradient: "from-orange-400 to-red-500",
      bgGradient: "from-orange-50 to-red-50"
    };
  }
  // Sore: 15:01-18:00
  else if (currentTime >= 15.02 && currentTime <= 18) {
    return {
      greeting: "Selamat Sore",
      icon: "fa-cloud-sun", 
      gradient: "from-orange-500 to-purple-500",
      bgGradient: "from-orange-50 to-purple-50"
    };
  }
  // Malam: 18:01-02:58
  else {
    return {
      greeting: "Selamat Malam",
      icon: "fa-moon",
      gradient: "from-purple-500 to-blue-600", 
      bgGradient: "from-purple-50 to-blue-50"
    };
  }
};

export const formatCurrentTime = () => {
  return new Date().toLocaleTimeString('id-ID', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};